var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "X_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1981.15 2027.28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".X_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "X_svg__cls-1",
    d: "M1838.84 1820.49 1175.02 856.1l-75.05-109.07L625.13 57.17 585.77 0H2.28l142.3 206.79 631.37 917.35L851 1233.09l507.3 737.07 39.35 57.11h583.49l-142.3-206.79ZM1467 1895.3l-527.04-765.75-75.05-109.01-611.56-888.56h263.07L1011 850.57l75.05 109.01 644.02 935.71H1467Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "X_svg__cls-1",
    d: "m864.92 1020.54 75.05 109.01L851 1233.09l-682.66 794.19H0l775.95-903.13 88.97-103.61zM1910.89 0l-735.87 856.1-88.97 103.49L1011 850.58l88.97-103.55 498.48-580.19L1742.55 0h168.34z"
  })));
};
export default SvgX;